import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router';
import Navigation from '../../constants/enums/NavigationEnum'
import HomeIcon from '../../images/dynamicIcons/homeIcon'
import GridIcon from '../../images/dynamicIcons/gridIcon'
import ChartIcon from '../../images/dynamicIcons/chartIcon'
import ChatIcon from '../../images/dynamicIcons/chatIcon'


const tabs = [
    { name: "Главная", href: Navigation.GeneralPage, icon: <HomeIcon />, available: true },
    { name: "Услуги", href: Navigation.ServiceList, icon: <GridIcon />, available: false },
    { name: "Заявки", href: Navigation.AppealListPage, icon: <ChartIcon />, available: true },
    //{ name: "Финансы", href: Navigation.FinancePage, icon: <WalletIcon />, available: true },
    { name: "Чат", href: Navigation.Chat, icon: <ChatIcon />, available: false }
]

type FooterProps = RouteComponentProps

interface FooterState {
}

class Footer extends React.PureComponent<FooterProps, FooterState> {

    constructor(props: FooterProps) {
        super(props);
        this.state = {
        }

        this.IsCurrentpPath = this.IsCurrentpPath.bind(this);
    }

    IsCurrentpPath(expectedPath: string) {
        let path = this.props.location.pathname?.toLowerCase();
        return path === expectedPath || path.startsWith(expectedPath.toLowerCase())
    }

 

    public render() {
        return (
            <div className='footer' style={{
                display: this.props.location.pathname.toLocaleLowerCase() === Navigation.SubscriptionPage.toLocaleLowerCase()
                    ? "none" : ""
            }}>
                <div className='footer__nav'>
                    {tabs.map((element, index) => {
                        return <div className={`footer__nav_item 
                        ${this.IsCurrentpPath(element.href) && "selected"}
                        ${!element.available && "disabled"}`} key={index}
                            onClick={() => {
                                if (element.available)
                                    this.props.history.push(element.href)
                            }}
                        >
                            {element.icon}
                            <div className='footer-nav-text'>{element.name}</div>
                        </div>
                    })}
                </div>
            </div>
        );
    }
}

export default connect(
    null,
    null
)(withRouter(Footer) as any);